import * as React from 'react';

const TrapChild = /*#__PURE__*/ React.forwardRef(({ children  }, ref)=>/*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, children)
);

export { TrapChild };
//# sourceMappingURL=TrapChild.js.map
